import {LifecycleManager} from "./_base-lifecycles";

import removeEmptyPTags from "../global/cleanup-p-tags";
import setCustomProperties from "../global/set-css-custom-props";
import preloadImages from "../global/preload-images";
import preventLinksInEditor from "../editor/prevent-links-in-editor";
import {initializeSlider, initializeSliderEditor } from "../components/slider";
import {initializeAccordions} from "../components/accordion";
import {initializeModals, initializeModalsEditor} from "../components/modal";
import {InitForm} from "../components/contact-forms";
import {initializePostFeeds} from "../components/post-feed";
import {initializeVideo} from "../components/video";
import {initializeNav} from "../components/nav";
import {initializePV} from "../global/init-petite-vue";
import {InitializeGSAPOnPageLoad} from "../utility/init-gsap"; 
import {localAdminBarUpdater} from "../utility/utils";
import { InitTabbedContainer, InitTabbedContainerEditor } from '../components/tabbed-container.js';

/**************************************************
 Event Definitions
 **************************************************/
const EVENTS = Object.freeze({
    /**
     * This event is called first thing in the editor and main.js files
     * @type {Symbol<'Initialize'>}
     */
    INIT: Symbol('Initialize'),
    /**
     * This event is called when the document is ready in the editor and main.js files
     * @type {Symbol<'Document Ready'>}
     */
    DOCUMENT_READY:Symbol('Document Ready'),
    /**
     * This event is called on the window `load` event in the editor and main.js files
     * @type {Symbol<'Window Load'>}
     */
    WINDOW_LOAD:Symbol('Window Load'),
    /**
     * This event is called once all images have loaded in the main.js file
     * @type {Symbol<'Page Loaded'>}
     */
    PAGE_LOADED:Symbol('Page Loaded'),
})


/**************************************************
   Main Lifecycle
 **************************************************/
const MainLifecycleManager = new LifecycleManager();


MainLifecycleManager
    .registerEvent(EVENTS.DOCUMENT_READY, InitializeGSAPOnPageLoad)
    .registerEvent(EVENTS.DOCUMENT_READY, initializeAccordions)
    .registerEvent(EVENTS.DOCUMENT_READY, initializeModals)
    .registerEvent(EVENTS.DOCUMENT_READY, initializeVideo)
    .registerEvent(EVENTS.DOCUMENT_READY, initializeNav)
    .registerEvent(EVENTS.DOCUMENT_READY, removeEmptyPTags)
    .registerEvent(EVENTS.DOCUMENT_READY, setCustomProperties)
    .registerEvent(EVENTS.DOCUMENT_READY, InitForm)
    .registerEvent(EVENTS.DOCUMENT_READY, initializePostFeeds)
    .registerEvent(EVENTS.DOCUMENT_READY, InitTabbedContainer)



MainLifecycleManager
    .registerEvent(EVENTS.WINDOW_LOAD, initializeSlider)
    .registerEvent(EVENTS.WINDOW_LOAD, preloadImages)
    .registerEvent(EVENTS.WINDOW_LOAD, initializePV)



MainLifecycleManager
    .registerEvent(EVENTS.PAGE_LOADED, localAdminBarUpdater)



/**************************************************
 Editor Lifecycle
 **************************************************/
const EditorLifecycleManager = new LifecycleManager();

EditorLifecycleManager
    .registerEvent(EVENTS.DOCUMENT_READY, initializeModalsEditor)
    .registerEvent(EVENTS.DOCUMENT_READY, initializeAccordions)
    .registerEvent(EVENTS.DOCUMENT_READY, initializeVideo)
    .registerEvent(EVENTS.DOCUMENT_READY, preventLinksInEditor)
    .registerEvent(EVENTS.DOCUMENT_READY, initializeSliderEditor)
    .registerEvent(EVENTS.DOCUMENT_READY, InitTabbedContainerEditor)



export {
    EVENTS,
    MainLifecycleManager,
    EditorLifecycleManager
}